{
  "version": 1,
  "asset_id": "e1a55a7d-85b5-4562-94b5-f4799242fde2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e1a55a7d-85b5-4562-94b5-f4799242fde2/sleeve-ugi-reflux-pre-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e1a55a7d-85b5-4562-94b5-f4799242fde2/sleeve-ugi-reflux-pre-800.jpg",
  "original_filename": "sleeve-ugi-reflux-pre-800.jpg",
  "size": 78797,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T16:41:38Z"
}
